import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BoostrapVue, { BootstrapVueIcons } from 'bootstrap-vue'
import VueForm from 'vue-form'
import VueQuillEditor from 'vue-quill-editor'
import ResourcesPlugin from './plugins/resources'

import './directives'
import messages from './mixins/messages'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import './assets/main.scss'
import './assets/style.scss'
import { IS_DEV } from './config'

if (!IS_DEV && !window.location.href.match(/^https:/)) {
    window.location.href = window.location.href.replace(/^http:/, 'https:')
}

Vue.config.productionTip = false

Vue.use(BoostrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueForm)
Vue.use(VueQuillEditor)
Vue.use(ResourcesPlugin)

Vue.mixin(messages)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
